export const pc_routes = [
  {
    path: '/pc/index',
    redirect: '/pc/mall'
  },
  {
    path: '/pc',
    redirect: '/pc/mall'
  },
  {
    path: '/pc/home',
    name: 'home',
    component: () => import('@/views/pc/index.vue'),
  }, {
    path: '/pc/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/pc/aboutUs.vue'),
  }, {
    path: '/pc/productIntroduction',
    name: 'productIntroduction',
    component: () => import('@/views/pc/productIntroduction.vue'),
  }, {
    path: '/pc/usinessPartner',
    name: 'usinessPartner',
    component: () => import('@/views/pc/usinessPartner.vue'),
  }, {
    path: '/pc/joinUs',
    name: 'joinUs',
    component: () => import('@/views/pc/joinUs.vue'),
  },
  {
    path: '/pc/companyDevelopt',
    name: 'companyDevelopt',
    component: () => import('@/views/pc/companyDevelopt.vue'),
  },
  {
    path: '/pc/mall',
    name: 'mall',
    component: () => import('@/views/pc/mall/index.vue'),
    children: [
      {
        path: 'category/:categoryId/:categoryName',
        name: 'mallCategory',
        component: () => import('@/views/pc/mall/category.vue'),
      },
      {
        path: 'product/:productId',
        name: 'mallProduct',
        component: () => import('@/views/pc/mall/product.vue'),
      },
      {
        path: 'shopVerify',
        name: 'mallShopVerify',
        component: () => import('@/views/pc/mall/validate.vue')
      },
      {
        path: 'shopIntro',
        name: 'mallShopIntro',
        component: () => import('@/views/pc/mall/shopIntro.vue'),
      },
      {
        path: 'allProducts',
        name: 'mallProducts',
        component: () => import('@/views/pc/mall/allProducts.vue'),
      },
      {
        path: 'hotProducts',
        name: 'mallHotProducts',
        component: () => import('@/views/pc/mall/hotProducts.vue'),
      },
      {
        path: 'cart',
        name: 'mallCart',
        component: () => import('@/views/pc/mall/cart.vue'),
      },
      {
        path: 'mine',
        name: 'mallMine',
        component: () => import('@/views/pc/mall/mine.vue'),
      },
    ]
  },
  {
    path: '/pc/userAgreement',
    name: 'userAgreement',
    component: () => import('@/views/pc/userAgreement.vue'),
  },
  {
    path: '*',
    component: () => import('@/views/pc/mall/index.vue'),
  },
]
